import "./contact.css"
import { Link } from "react-router-dom"
function Contact(){
  const gettop=()=>{
    window.scrollTo({
      top:0,
      behavior:"smooth"
    })
  }
    return(
        <>
        <div className="contact m-2">
            <div className="continer">
                <div className="row">
                   <div className="col-md-6">
  <div className="maps   rounded   ">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18..."
      width="100%"
      height="350"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      className="rounded"
    ></iframe>
  </div>
</div>
                    <div className="col-md-6 mt-3">
  <div className="text">
  <h4>Contact Us</h4>
  <h5>
    We are here to help you. Feel free to contact us for any questions,
    support, or to book an appointment with our team. Our dedicated staff
    will respond promptly and guide you through every step. Whether you
    need medical advice, scheduling assistance, or general information,
    we are committed to providing clear answers and professional care.
    Reach out today and let us make your experience smooth and reassuring.
  </h5>
</div>

  <div className="buttons mt-3">
    <button className="btn btn-danger me-2">
      Book Appointment
    </button>
                <Link to="/Contact"  className="nav-link mt-2"  onClick={gettop}>
 <button className="btn btn-outline-danger">
      Contact Us
    </button>                 </Link>

   
  </div>

  <div className="icon mt-4">
       <i className="fa-brands fa-facebook"></i>
      <i className="fa-brands fa-linkedin ms-3"></i>
      <i className="fa-brands fa-github ms-3"></i>
      <i class="fa-brands fa-twitter  ms-3"></i>
      <i class="fa-brands fa-threads ms-3"></i>
  </div>
</div>
                </div>

            </div>
        </div>
        </>
    )
}
export default Contact